import APPLICATION_CONSTANTS from "../helper/application-conf";
import { Environment, environmentService } from "./environmentService";

const environment = new environmentService();
declare const window: any;

export class OneIdentityService {

    oneIdentityURL() {
        const env = environment.getEnvironment();
        let headerURL = APPLICATION_CONSTANTS.ONE_IDENTITY_E3_URL
        if (env == Environment.Dev) {
            headerURL = APPLICATION_CONSTANTS.ONE_IDENTITY_E1_URL;
        }
        else if (env == Environment.Stage) {
            headerURL = APPLICATION_CONSTANTS.ONE_IDENTITY_E2_URL;
        }
        else {
            headerURL = APPLICATION_CONSTANTS.ONE_IDENTITY_E3_URL;
        }
        return headerURL;
    }

    oneIdentityPasswordResetURL() {
        const env = environment.getEnvironment();
        let passwordResetURL = APPLICATION_CONSTANTS.ONE_IDENTITY_PASSWORD_E3_URL
        if (env == Environment.Dev) {
            passwordResetURL = APPLICATION_CONSTANTS.ONE_IDENTITY_PASSWORD_E1_URL;
        }
        else if (env == Environment.Stage) {
            passwordResetURL = APPLICATION_CONSTANTS.ONE_IDENTITY_PASSWORD_E2_URL;
        }
        else {
            passwordResetURL = APPLICATION_CONSTANTS.ONE_IDENTITY_PASSWORD_E3_URL
        }
        return passwordResetURL;
    }

    oneIdentityManageProfileURL() {
        const env = environment.getEnvironment();
        let manageProfileURL = APPLICATION_CONSTANTS.ONE_IDENTITY_MANAGE_E3_URL;
        if (env == Environment.Dev) {
            manageProfileURL = APPLICATION_CONSTANTS.ONE_IDENTITY_MANAGE_E1_URL;
        }
        else if (env == Environment.Stage) {
            manageProfileURL = APPLICATION_CONSTANTS.ONE_IDENTITY_MANAGE_E2_URL;
        }
        else {
            manageProfileURL = APPLICATION_CONSTANTS.ONE_IDENTITY_MANAGE_E3_URL;
        }
        return manageProfileURL;
    }

    oneApURL() {
        const env = environment.getEnvironment();
        let headerURL = APPLICATION_CONSTANTS.ONE_AP_E3_URL
        if (env == Environment.Dev) {
            headerURL = APPLICATION_CONSTANTS.ONE_AP_E1_URL;
        }
        else if (env == Environment.Stage) {
            headerURL = APPLICATION_CONSTANTS.ONE_AP_E2_URL;
        }
        else {
            headerURL = APPLICATION_CONSTANTS.ONE_AP_E3_URL;
        }
        return headerURL;
    }

    usmURL() {
        const env = environment.getEnvironment();
        let urlUSM = APPLICATION_CONSTANTS.USM_E3_URL
        if (env == Environment.Dev) {
            urlUSM = APPLICATION_CONSTANTS.USM_E1_URL;
        }
        else if (env == Environment.Stage) {
            urlUSM = APPLICATION_CONSTANTS.USM_E2_URL;
        }
        else {
            urlUSM = APPLICATION_CONSTANTS.USM_E3_URL;
        }
        return urlUSM;
    }

    async isOneIdAuthenticatedWithPolling(): Promise<boolean> {
        return new Promise((resolve) => {
            const checkSession = () => {
                if (window && window.AmexSession && typeof window.AmexSession.isAuthenticated === 'function') {
                    resolve(window.AmexSession.isAuthenticated());
                } else {
                    setTimeout(checkSession, 100);
                }
            };
            checkSession();
        });
    }

}